import { render, staticRenderFns } from "./AdminTicket.vue?vue&type=template&id=4f045f28&scoped=true&"
import script from "./AdminTicket.vue?vue&type=script&lang=js&"
export * from "./AdminTicket.vue?vue&type=script&lang=js&"
import style0 from "./AdminTicket.vue?vue&type=style&index=0&id=4f045f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f045f28",
  null
  
)

export default component.exports